{
  "list": {
    "title": "Filter",
    "create": "Filter erstellen",
    "import": "Filter importieren",
    "loadError": "Beim Laden der Filter ist ein Fehler aufgetreten.",
    "statusAll": "Alle",
    "statusEnabled": "Aktiviert",
    "statusDisabled": "Deaktiviert",
    "noStatusFilters": "Keine {{status}} Filter",
    "noFilters": "Keine Filter vorhanden..",
    "addNew": "Neu hinzufügen",
    "copied": "Filter in Zwischenablage kopiert!",
    "copyFailed": "JSON konnte nicht in die Zwischenablage kopiert werden.",
    "fetchFailed": "Filterdaten konnten nicht abgerufen werden.",
    "deleted": "Filter {{name}} wurde gelöscht",
    "duplicated": "Filter {{name}} wurde dupliziert",
    "updated": "{{name}} wurde erfolgreich aktualisiert",
    "removeTitle": "Filter entfernen: {{name}}",
    "removeText": "Bist du sicher, dass du diesen Filter entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "edit": "Bearbeiten",
    "exportJson": "JSON exportieren",
    "exportJsonDiscord": "JSON nach Discord exportieren",
    "toggle": "Umschalten",
    "duplicate": "Duplizieren",
    "delete": "Löschen",
    "toggleSuccess": "{{name}} wurde erfolgreich {{state}}",
    "enabledState": "aktiviert",
    "disabledState": "deaktiviert",
    "autoUpdatedTitle": "Dieser Filter wird automatisch von einer Liste aktualisiert",
    "priority": "Priorität",
    "actions": "Aktionen",
    "noActionsDefined": "Keine Aktionen definiert. Aktionen einrichten um Snatching zu aktivieren.",
    "noActionsEnabled": "Du musst mindestens eine Aktion im Filter aktivieren, sonst gibt es keine Snatches.",
    "downloads": "Downloads",
    "per": "pro",
    "usesDisabledIndexers": "Verwendet deaktivierte(n) Indexer: {{names}}",
    "noIndexer": "KEIN INDEXER",
    "sort": {
      "label": "Sortierung",
      "default": "Neueste",
      "nameAsc": "Name A-Z",
      "nameDesc": "Name Z-A",
      "priorityDesc": "Priorität Hoch - Niedrig",
      "priorityAsc": "Priorität Niedrig - Hoch",
      "createdDesc": "Kürzlich erstellte zuerst",
      "createdAsc": "Kürzlich erstellte zuletzt",
      "updatedDesc": "Kürzlich aktualisierte zuerst",
      "updatedAsc": "Kürzlich aktualisierte zuletzt"
    },
    "indexerFilter": {
      "label": "Indexer",
      "all": "Alle Indexer"
    }
  },
  "details": {
    "tabs": {
      "general": "Allgemein",
      "moviesTv": "Filme & Serien",
      "music": "Musik",
      "advanced": "Erweitert",
      "external": "Extern",
      "actions": "Aktionen",
      "notifications": "Benachrichtigungen",
      "new": "NEU"
    },
    "removeTitle": "Filter entfernen: {{name}}",
    "removeText": "Bist du sicher, dass du diesen Filter entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "delete": "Filter löschen",
    "reset": "Formularwerte zurücksetzen",
    "resetSuccess": "Alle Filterwerte zurückgesetzt.",
    "save": "Speichern",
    "validationError": "Validierungsfehler",
    "validationErrors": "Validierungsfehler",
    "mustSelectClient": "Client muss ausgewählt werden"
  },
  "importer": {
    "title": "Filter importieren (im JSON- oder autodl-irssi-Format)",
    "import": "Importieren",
    "cancel": "Abbrechen",
    "jsonImported": "Filter '{{name}}' erfolgreich importiert!",
    "jsonImportFailed": "JSON-Daten konnten nicht importiert werden. Informationen wurden in der Konsole protokolliert.",
    "invalidFormat": "Filter kann nicht importiert werden – weder im JSON- noch im autodl-irssi-Format.",
    "autodlImportFailed": "autodl-irssi-Filter '{{name}}' konnte nicht importiert werden. Informationen wurden in der Konsole protokolliert.",
    "autodlImportedOne": "Filter '{{name}}' erfolgreich importiert!",
    "autodlImportedMany": "Alle {{count}} Filter erfolgreich importiert!",
    "autodlImportedPartial": "{{success}}/{{total}} Filter erfolgreich importiert. Siehe Konsole für Details.",
    "placeholder": "Filterdaten hier einfügen (entweder autobrr JSON-Format oder die gesamte autodl-irssi-Konfiguration)",
    "warnings": "Importwarnungen"
  },
  "general": {
    "filterName": "Filtername",
    "filterNamePlaceholder": "z.B. Filter 1",
    "announceTypes": "Ankündigungstypen",
    "announceTypesTooltip": "NEU! Releases mit einem der ausgewählten Ankündigungstypen filtern.",
    "indexers": "Indexer",
    "rulesTitle": "Regeln",
    "rulesSubtitle": "Regeln festlegen, wie Torrents behandelt/ausgewählt werden sollen.",
    "minSize": "Min. Größe",
    "maxSize": "Max. Größe",
    "sizePlaceholder": "z.B. 100MiB, 80GB",
    "sizeTooltip": "Unterstützt Einheiten wie MB, MiB, GB usw.",
    "delay": "Verzögerung",
    "delayPlaceholder": "Anzahl Sekunden für die Verzögerung von Aktionen",
    "delayTooltip": "Anzahl der Sekunden, die vor dem Ausführen von Aktionen gewartet werden soll.",
    "priority": "Priorität",
    "priorityPlaceholder": "Höhere Zahl = höhere Priorität",
    "priorityTooltip": "Filter werden in der Reihenfolge ihrer Priorität überprüft. Höhere Zahl = höhere Priorität.",
    "maxDownloads": "Max. Downloads",
    "maxDownloadsPlaceholder": "Beliebige Zahl (0 ist unbegrenzt)",
    "maxDownloadsTooltip": "Anzahl der maximalen Downloads gemäß der entsprechenden Einheit.",
    "maxDownloadsPer": "Max. Downloads pro",
    "selectUnit": "Einheit wählen",
    "maxDownloadsPerTooltip": "Die Zeiteinheit für die Zählung der maximalen Downloads pro Filter.",
    "skipDuplicatesProfile": "Duplikatprofil überspringen",
    "selectProfile": "Profil wählen",
    "skipDuplicatesProfileTooltip": "Das Duplikatprofil zum Überspringen auswählen.",
    "enabled": "Aktiviert",
    "enabledDescription": "Diesen Filter aktivieren oder deaktivieren."
  },
  "actionsSection": {
    "title": "Aktionen",
    "subtitle": "Zu Downloadclients hinzufügen oder benutzerdefinierte Befehle ausführen.",
    "addNew": "Neu hinzufügen",
    "empty": "Noch keine Aktionen!",
    "deleted": "Aktion {{name}} wurde gelöscht",
    "removeTitle": "Filteraktion entfernen",
    "removeText": "Bist du sicher, dass du diese Aktion entfernen möchtest? Dies kann nicht rückgängig gemacht werden.",
    "actionTitle": "Aktion",
    "actionSubtitle": "Den Downloadclient für diese Aktion und seinen Namen definieren",
    "actionType": "Aktionstyp",
    "selectType": "Typ wählen",
    "actionTypeTooltip": "Den Aktionstyp für diese Aktion auswählen.",
    "name": "Name",
    "removeAction": "Aktion entfernen",
    "close": "Schließen"
  },
  "notificationsSection": {
    "title": "Filterbenachrichtigungen",
    "subtitle": "Konfiguriere, welche Benachrichtigungen für diesen Filter gesendet werden sollen. Diese überschreiben die globalen Benachrichtigungseinstellungen.",
    "addNotification": "Benachrichtigung hinzufügen",
    "empty": "Keine filterspezifischen Benachrichtigungen konfiguriert. Globale Benachrichtigungen werden verwendet.",
    "selectNotification": "Benachrichtigung wählen",
    "muted": "Stummgeschaltet",
    "eventsCount_one": "{{count}} Ereignis",
    "eventsCount_other": "{{count}} Ereignisse",
    "removeTitle": "Benachrichtigung entfernen",
    "removeText": "Bist du sicher, dass du diese Benachrichtigung entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "notificationTitle": "Benachrichtigung",
    "notificationSubtitle": "Benachrichtigungsdienst und auszulösende Ereignisse auswählen",
    "notificationService": "Benachrichtigungsdienst",
    "selectNotificationService": "Benachrichtigung wählen",
    "notificationServiceTooltip": "Den Benachrichtigungsdienst für diesen Filter auswählen.",
    "notificationSettings": "Benachrichtigungseinstellungen",
    "muteFilter": "Filter stummschalten",
    "muteFilterDesc": "Alle Benachrichtigungen für diesen Filter deaktivieren. Wenn stummgeschaltet, werden keine Benachrichtigungen für Releases gesendet, die diesem Filter entsprechen.",
    "mutedInfo": "Filter stummgeschaltet – überschreibt alle globalen Benachrichtigungseinstellungen",
    "triggerEvents": "Auslöseereignisse",
    "pushApproved": "Push angenommen",
    "pushRejected": "Push abgelehnt",
    "pushError": "Push fehlerhaft",
    "pushApprovedDesc": "Benachrichtigung senden, wenn Release erfolgreich an Client gesendet wurde",
    "pushRejectedDesc": "Benachrichtigung senden, wenn Release abgelehnt wird",
    "pushErrorDesc": "Benachrichtigung senden, wenn ein Fehler bei der Verarbeitung auftritt",
    "removeNotification": "Benachrichtigung entfernen",
    "close": "Schließen"
  },
  "advanced": {
    "common": {
      "useRegex": "Regex verwenden",
      "regexTooltip1": "Dieses Feld unterstützt vollständig Regex (Golang-Stil).",
      "regexTooltip2": "Vergiss nicht, Regex verwenden zu aktivieren, wenn mehr als * und ? verwendet wird.",
      "regexTooltip3": "Modus: (?i) Groß-/Kleinschreibung ignorieren"
    },
    "releases": {
      "title": "Releasenamen",
      "subtitle": "Nur bestimmte Releasenamen filtern und/oder andere ausschließen.",
      "match": "Releases filtern",
      "matchPlaceholder": "z.B. *some?movie*,*some?show*s01*",
      "except": "Releases ausschließen",
      "exceptPlaceholder": "z.B. *bad?movie*,*bad?show*s03*",
      "alert": "Frage dich selbst:",
      "matchWarning": "Hast du einen guten Grund, Releases zu filtern anstelle eines anderen Tabs zu verwenden?",
      "exceptWarning": "Hast du einen guten Grund, Releases zu ignorieren anstelle eines anderen Tabs zu verwenden?"
    },
    "groups": {
      "title": "Gruppen",
      "subtitle": "Nur bestimmte Gruppen filtern und/oder andere ausschließen.",
      "match": "Releasegruppen filtern",
      "matchPlaceholder": "z.B. gruppe1,gruppe2",
      "matchTooltip": "Durch Komma getrennte Liste von Releasegruppen zum Filtern.",
      "except": "Releasegruppen ausschließen",
      "exceptPlaceholder": "z.B. schlechtegruppe1,schlechtegruppe2",
      "exceptTooltip": "Durch Komma getrennte Liste von Releasegruppen die ausgeschlossen werden (hat Vorrang vor Releasegruppen filtern)."
    },
    "categories": {
      "title": "Kategorien",
      "subtitle": "Kategorien filtern oder ausschließen (wenn angekündigt)",
      "match": "Kategorien filtern",
      "matchPlaceholder": "z.B. *kategorie*,kategorie1",
      "matchTooltip": "Durch Komma getrennte Liste von Kategorien zum Filtern.",
      "except": "Kategorien ausschließen",
      "exceptPlaceholder": "z.B. *kategorie*",
      "exceptTooltip": "Durch Komma getrennte Liste von Kategorien die ausgeschlossen werden (hat Vorrang vor Kategorien filtern)."
    },
    "tags": {
      "title": "Tags",
      "subtitle": "Tags filtern oder ausschließen (wenn angekündigt)",
      "match": "Tags filtern",
      "matchPlaceholder": "z.B. tag1,tag2",
      "matchTooltip": "Durch Komma getrennte Liste von Tags zum Filtern.",
      "matchLogic": "Filterlogik",
      "matchLogicDefault": "beliebig",
      "matchLogicTooltip": "Logik zum Filtern von Tags.",
      "except": "Tags ausschließen",
      "exceptPlaceholder": "z.B. tag1,tag2",
      "exceptTooltip": "Durch Komma getrennte Liste von Tags die ausgeschlossen werden (hat Vorrang vor Tags filtern).",
      "exceptLogic": "Ausschlusslogik",
      "exceptLogicDefault": "beliebig",
      "exceptLogicTooltip": "Logik zum Filtern von ausgeschlossenen Tags."
    },
    "uploaders": {
      "title": "Uploader",
      "subtitle": "Uploader filtern oder ausschließen (wenn angekündigt)",
      "match": "Uploader filtern",
      "matchPlaceholder": "z.B. uploader1,uploader2",
      "matchTooltip": "Durch Komma getrennte Liste von Uploadern zum Filtern.",
      "except": "Uploader ausschließen",
      "exceptPlaceholder": "z.B. anonym1,anonym2",
      "exceptTooltip": "Durch Komma getrennte Liste von Uploadern die ausgeschlossen werden (hat Vorrang vor Uploader filtern)."
    },
    "language": {
      "title": "Sprache",
      "subtitle": "Sprachen filtern oder ausschließen (wenn angekündigt)",
      "match": "Sprache filtern",
      "except": "Sprache ausschließen"
    },
    "origins": {
      "title": "Herkunft",
      "subtitle": "Internals, Scene, P2P usw. filtern (wenn angekündigt)",
      "match": "Herkunft filtern",
      "except": "Herkunft ausschließen"
    },
    "freeleech": {
      "title": "Freeleech",
      "subtitle": "Basierend auf Freeleech filtern (wenn angekündigt)",
      "percent": "Freeleechprozentsatz",
      "percentPlaceholder": "z.B. 50,75-100",
      "percentTooltip1": "Freeleech kann je nach Indexer als binärer wahr/falsch-Wert oder als Prozentsatz angekündigt werden. Eines von beiden verwenden.",
      "percentTooltip2": "Der Freeleechschalter überschreibt dieses Feld, wenn er aktiviert/wahr ist.",
      "percentTooltip3": "Weitere Details in unserer Dokumentation:",
      "toggle": "Freeleech",
      "toggleDescription": "Kann nicht mit Freeleechprozentsatz verwendet werden. Überschreibt Freeleech-Prozentsatz wenn aktiviert/wahr.",
      "toggleTooltip1": "Freeleech kann je nach Indexer als binärer wahr/falsch-Wert oder als Prozentsatz angekündigt werden. Eines von beiden verwenden.",
      "toggleTooltip2": "Dieses Feld überschreibt den Freeleechprozentsatz wenn aktiviert/wahr.",
      "toggleTooltip3": "In der Dokumentation nachsehen, wer was verwendet:"
    },
    "feedSpecific": {
      "title": "RSS/Torznab/Newznab-spezifisch",
      "subtitle": "Diese Optionen gelten nur für Feeds wie RSS, Torznab und Newznab",
      "matchDescription": "Beschreibung filtern",
      "matchDescriptionPlaceholder": "z.B. *some?movie*,*some?show*s01*",
      "exceptDescription": "Beschreibung ausschließen",
      "exceptDescriptionPlaceholder": "z.B. *bad?movie*,*bad?show*s03*",
      "minSeeders": "Min. Seeder",
      "maxSeeders": "Max. Seeder",
      "minLeechers": "Min. Leecher",
      "maxLeechers": "Max. Leecher",
      "countPlaceholder": "Beliebige Zahl (0 ist unbegrenzt)",
      "seedersTooltip": "Anzahl der {{type}} gemäß der entsprechenden Einheit. Nur für Torznab"
    },
    "rawReleaseTags": {
      "title": "Rohe Releasetags",
      "subtitlePrefix": "Nur für fortgeschrittene Benutzer",
      "subtitleSuffix": "Dies ist der rohe releaseTags-String aus der Ankündigung.",
      "warning": "Dies ist möglicherweise nicht das, was du denkst. Für sehr fortgeschrittene Benutzer, die wissen, wie Dinge geparst werden.",
      "match": "Releasetags filtern",
      "except": "Releasetags ausschließen",
      "placeholder": "z.B. *mkv*,*foreign*"
    }
  },
  "moviesTv": {
    "title": "Filme / Serien",
    "placeholder": "z.B. Film,Serie 1,Serie?2",
    "wildcardTooltip": "Grundlegendes Filtern mit Platzhaltern * oder einzelne Zeichen mit ? ersetzen",
    "years": "Jahre",
    "yearsPlaceholder": "z.B. 2018,2019-2021",
    "yearsTooltip": "Dieses Feld nimmt einen Jahresbereich und/oder durch Komma getrennte Einzeljahre.",
    "seasonEpisode": {
      "title": "Staffeln, Folgen und Datum",
      "subtitle": "Staffel-, Folgen-, Jahr-, Monats- und Tagfilter-Einschränkungen festlegen.",
      "seasons": "Staffeln",
      "seasonsPlaceholder": "z.B. 1,3,2-6",
      "seasonsTooltip": "Dokumentation für Informationen zum ausschließlichen Abrufen von ganzen Staffeln:",
      "episodes": "Folgen",
      "episodesPlaceholder": "z.B. 2,4,10-20",
      "episodesTooltip": "Dokumentation für Informationen zum ausschließlichen Abrufen von Folgen:",
      "dailyShows": "Tägliche Sendungen",
      "months": "Monate",
      "monthsPlaceholder": "z.B. 4,2-9",
      "monthsTooltip": "Dieses Feld nimmt einen Monatsbereich und/oder durch Komma getrennte Einzelmonate.",
      "days": "Tage",
      "daysPlaceholder": "z.B. 1,15-30",
      "daysTooltip": "Dieses Feld nimmt einen Tagesbereich und/oder durch Komma getrennte Einzeltage.",
      "smartEpisode": "Intelligente Folge",
      "smartEpisodeDescription": "Keine Folgen filtern, die älter sind als die zuletzt gefilterte."
    },
    "quality": {
      "title": "Qualität",
      "subtitle": "Auflösung, Quelle, Codec und verwandte Filtereinschränkungen festlegen.",
      "resolutions": "Auflösungen",
      "resolutionsTooltip": "Filtert Releases, die eine der ausgewählten Auflösungen enthalten.",
      "sources": "Quellen",
      "sourcesTooltip": "Filtert Releases, die eine der ausgewählten Quellen enthalten.",
      "codecs": "Codecs",
      "codecsTooltip": "Filtert Releases, die einen der ausgewählten Codecs enthalten.",
      "containers": "Container",
      "containersTooltip": "Filtert Releases, die einen der ausgewählten Container enthalten.",
      "matchHdr": "HDR filtern",
      "matchHdrTooltip": "Filtert Releases, die eine der ausgewählten HDR-Bezeichnungen enthalten.",
      "exceptHdr": "HDR ausschließen",
      "exceptHdrTooltip": "Schließt Releases aus, die eine der ausgewählten HDR-Bezeichnungen enthalten (hat Vorrang vor HDR filtern).",
      "matchOther": "Sonstiges filtern",
      "matchOtherTooltip": "Filtert Releases, die eine der ausgewählten Bezeichnungen enthalten.",
      "exceptOther": "Sonstiges ausschließen",
      "exceptOtherTooltip": "Schließt Releases aus, die eine der ausgewählten sonstigen Bezeichnungen enthalten (hat Vorrang vor Sonstiges filtern)."
    }
  },
  "music": {
    "artists": "Künstler",
    "artistsPlaceholder": "z.B. Künstler Eins",
    "albums": "Alben",
    "albumsPlaceholder": "z.B. Jenes Album",
    "wildcardTooltip": "Grundlegendes Filtern mit Platzhaltern * oder einzelne Zeichen mit ? ersetzen",
    "matchRecordLabels": "Plattenlabels filtern",
    "matchRecordLabelsPlaceholder": "z.B. Anjunabeats, Armada",
    "matchRecordLabelsTooltip": "Durch Komma getrennte Liste von Plattenlabels zum filtern. Nur Orpheus und Redacted unterstützen dies.",
    "exceptRecordLabels": "Plattenlabels ausschließen",
    "exceptRecordLabelsPlaceholder": "z.B. Anjunadeep, Armind",
    "exceptRecordLabelsTooltip": "Durch Komma getrennte Liste von Plattenlabels die ausgeschlossen werden (hat Vorrang vor Plattenlabels filtern). Nur Orpheus und Redacted unterstützen dies.",
    "releaseDetails": {
      "title": "Releasedetails",
      "subtitle": "Typ (Album, Single, EP usw.) und Erscheinungsjahr (wenn angekündigt)",
      "musicType": "Musiktyp",
      "musicTypeTooltip": "Filtert nur Releases mit einem der ausgewählten Typen.",
      "years": "Jahre",
      "yearsPlaceholder": "z.B. 2018,2019-2021",
      "yearsTooltip": "Dieses Feld nimmt einen Jahresbereich und/oder durch Komma getrennte Einzeljahre."
    },
    "quality": {
      "title": "Qualität",
      "subtitle": "Format, Quelle, Log usw.",
      "format": "Format",
      "formatTooltip": "Filtert nur Releases mit einem der ausgewählten Formate. Wird von Perfect FLAC überschrieben.",
      "quality": "Qualität",
      "qualityTooltip": "Filtert nur Releases mit einer der ausgewählten Qualitäten. Wird von Perfect FLAC überschrieben.",
      "media": "Medium",
      "mediaTooltip": "Filtert nur Releases mit einer der ausgewählten Quellen. Wird von Perfect FLAC überschrieben.",
      "cue": "Cue",
      "cueDescription": "Muss CUE-Informationen enthalten",
      "log": "Log",
      "logDescription": "Muss Loginformationen enthalten",
      "logScore": "Logpunktzahl",
      "logScorePlaceholder": "z.B. 100",
      "logScoreTooltip": "Logpunktzahlen gehen von 0 bis 100. Wird von Perfect FLAC überschrieben.",
      "or": "ODER",
      "perfectFlac": "Perfect FLAC",
      "perfectFlacDescription": "Alle Optionen zu Qualität, Quelle, Format und CUE/Log/Log-Punktzahl überschreiben.",
      "perfectFlacTooltip": "Alle Optionen zu Qualität, Quelle, Format und CUE/Log/Log-Punktzahl überschreiben.",
      "perfectFlacHint": "Dies ist in 90% der Fälle die richtige Wahl (anstelle der obigen Optionen)."
    }
  },
  "external": {
    "title": "Externe Filter",
    "subtitle": "Externe Skripte oder Webhooks ausführen und Status als Teil des Filterns überprüfen.",
    "addNew": "Neu hinzufügen",
    "empty": "Noch keine externen Filter!",
    "removeTitle": "Externen Filter entfernen",
    "removeText": "Bist du sicher, dass du diesen externen Filter entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "sectionTitle": "Externer Filter",
    "sectionSubtitle": "Typ und Namen des Filters definieren",
    "type": "Typ",
    "name": "Name",
    "onError": "Bei Fehler",
    "selectType": "Typ wählen",
    "typeTooltip": "Den Typ für diesen externen Filter auswählen.",
    "onErrorTooltip": "Auswählen, was bei einem Fehler für diesen externen Filter getan werden soll.",
    "remove": "Extern entfernen",
    "close": "Schließen",
    "types": {
      "EXEC": "Exec",
      "WEBHOOK": "Webhook"
    },
    "onErrorOptions": {
      "REJECT": "Ablehnen",
      "CONTINUE": "Weiter zum nächsten"
    },
    "execute": {
      "title": "Ausführen",
      "subtitle": "Ausführbare Datei, Argument und erwarteten Exitstatus für die Vorfilterung angeben",
      "path": "Pfad zur ausführbaren Datei",
      "pathPlaceholder": "Absoluter Pfad zur ausführbaren Datei z.B. /bin/test",
      "pathTooltip": "Für benutzerdefinierte Befehle solltest du den vollständigen Pfad zur Binärdatei/zum Programm angeben. Du kannst auch eigene statische Variablen einschließen:",
      "args": "Execargumente",
      "argsPlaceholder": "Argumente z.B. --test \"{{ .TorrentName }}\"",
      "expectedExitStatus": "Erwarteter Exitstatus"
    },
    "request": {
      "title": "Anfrage",
      "subtitle": "Zielendpunkt, Header und erwarteten Rückgabestatus angeben",
      "endpoint": "Endpunkt",
      "endpointPlaceholder": "Host z.B. http://localhost/webhook",
      "endpointTooltip": "URL oder IP zu deiner API. Parameter übergeben und API-Token usw. festlegen.",
      "httpMethod": "HTTP-Methode",
      "httpMethodDefault": "HTTP-Methode wählen",
      "httpMethodTooltip": "Die HTTP-Methode für diesen Webhook auswählen. Standard ist POST",
      "headers": "HTTP-Anfrageheader",
      "headersPlaceholder": "HEADER=custom1,HEADER2=custom2",
      "expectedStatus": "Erwarteter HTTP-Statuscode"
    },
    "retry": {
      "title": "Wiederholen",
      "subtitle": "Wiederholungsverhalten bei Anfragefehler",
      "retryStatus": "HTTP-Statuscode(s) für Wiederholung",
      "retryStatusPlaceholder": "Wiederholen bei Status z.B. 202, 204",
      "retryAttempts": "Maximale Wiederholungsversuche",
      "retryDelaySeconds": "Wiederholungsverzögerung in Sekunden"
    },
    "payload": {
      "title": "Payload",
      "subtitle": "JSON-Payload angeben",
      "data": "Daten (JSON)",
      "dataPlaceholder": "Anfragedaten: { \"key\": \"value\" }"
    }
  },
  "actionComponents": {
    "instance": {
      "title": "Instanz",
      "subtitle": "Die spezifische Instanz auswählen, die diesen Releasefilter verarbeiten soll."
    },
    "common": {
      "category": "Kategorie",
      "categoryPlaceholder": "z.B. kategorie",
      "categoryTooltip": "Kategorie muss bereits vorhanden sein.",
      "savePath": "Speicherpfad",
      "savePathPlaceholder": "z.B. /vollständiger/pfad/zum/download_ordner",
      "numberNoLimit": "Beliebige Zahl (0 ist kein Limit)",
      "limitsTitle": "Limits",
      "limitsSubtitle": "Geschwindigkeits-/Ratio-/Seedzeit-Limits konfigurieren",
      "limitDownloadKib": "Downloadgeschwindigkeit begrenzen (KiB/s)",
      "limitUploadKib": "Uploadgeschwindigkeit begrenzen (KiB/s)",
      "limitDownloadKb": "Downloadgeschwindigkeit begrenzen (KB/s)",
      "limitUploadKb": "Uploadgeschwindigkeit begrenzen (KB/s)",
      "ratioLimit": "Ratiobegrenzung",
      "seedTimeMinutes": "Seedzeitlimit (Minuten)",
      "addPaused": "Angehalten hinzufügen",
      "addPausedDescription": "Torrent als angehalten hinzufügen",
      "skipHashCheck": "Hashprüfung überspringen",
      "skipHashCheckDescription": "Torrent hinzufügen und Hashprüfung überspringen",
      "announceTitle": "Ankündigung",
      "announceSubtitle": "Anzahl der Wiederankündigungen (bei Bedarf), Löschen nach Y Ankündigungsfehlern usw. festlegen.",
      "disableReannounce": "Wiederankündigung deaktivieren",
      "disableReannounceDescription": "Wiederankündigung ist standardmäßig aktiviert. Deaktivieren wenn nicht benötigt",
      "reannounceInterval": "Wiederankündigungsintervall. Alle X Sekunden ausführen",
      "reannounceIntervalPlaceholder": "7 ist Standard und empfohlen",
      "deleteStalled": "Abgebrochene löschen",
      "deleteStalledDescription": "Abgebrochene Torrents nach Y Versuchen löschen",
      "reannounceMaxAttempts": "Wiederankündigung Y Mal ausführen"
    },
    "test": {
      "alert": "Achtung!",
      "text": "Die Testaktion macht nichts außer zu zeigen, ob der Filter funktioniert. Stelle sicher, dass die Protokollseite während des Tests geöffnet ist."
    },
    "exec": {
      "title": "Execargumente",
      "subtitle": "Ausführbare Datei und Argumente angeben, die bei Filtertreffer ausgeführt werden sollen. Absoluten Pfad verwenden.",
      "path": "Pfad zur ausführbaren Datei",
      "pathPlaceholder": "Pfad zum Programm z.B. /bin/test",
      "arguments": "Argumente",
      "argumentsPlaceholder": "Argumente z.B. --test"
    },
    "watchFolder": {
      "title": "Watchordnerargumente",
      "subtitle": "Angeben, wohin autobrr die abgerufenen Dateien speichern soll. Absoluten Pfad verwenden.",
      "directory": "Watchverzeichnis",
      "directoryPlaceholder": "Watchverzeichnis z.B. /home/benutzer/rwatch"
    },
    "webhook": {
      "title": "Webhookargumente",
      "subtitle": "Die Nutzdaten angeben, die bei Filtertreffer an den gewünschten Endpunkt gesendet werden sollen.",
      "endpoint": "Endpunkt",
      "endpointPlaceholder": "Host z.B. http://localhost/webhook",
      "endpointTooltip": "URL oder IP zu deiner API. Parameter übergeben und API-Token usw. festlegen.",
      "payload": "Payload (JSON)",
      "payloadPlaceholder": "Anfragedaten: { \"key\": \"value\" }"
    },
    "arr": {
      "overrideClientName": "Downloadclientnamen für arr überschreiben",
      "overrideClientNameTooltip": "Downloadclientnamen von dem in Clients festgelegten überschreiben. Nützlich, wenn mehrere Clients innerhalb des arr vorhanden sind.",
      "overrideClientId": "Downloadclient-ID für arr überschreiben VERALTET",
      "overrideClientIdTooltip": "Downloadclient-ID von der in Clients festgelegten überschreiben. Nützlich, wenn mehrere Clients innerhalb des arr vorhanden sind."
    },
    "qbittorrent": {
      "macrosTooltip": "Das Feld kann Makros verwenden, um Werte aus Metadaten zu transformieren/hinzuzufügen:",
      "tags": "Tags",
      "tagsPlaceholder": "z.B. tag1,tag2",
      "savePathPlaceholder": "z.B. /vollständiger/pfad/zum/speicher_ordner",
      "savePathTooltip": "Einen benutzerdefinierten Speicherpfad für diese Aktion festlegen. Das automatische Torrentmanagement übernimmt dies, wenn qBittorrent mit Kategorien verwendet wird.",
      "downloadPath": "Downloadpfad",
      "downloadPathPlaceholder": "z.B. /vollständiger/pfad/zum/download_ordner",
      "downloadPathTooltip": "Einen benutzerdefinierten (unvollständigen) Downloadpfad für diese Aktion festlegen. Das automatische Torrentanagement übernimmt dies, wenn qBittorrent mit Kategorien verwendet wird.",
      "rulesTitle": "Regeln",
      "rulesSubtitle": "Torrentclientregeln konfigurieren",
      "ignoreRules": "Vorhandene Clientregeln ignorieren",
      "ignoreRulesDescription": "Regeln in den Clienteinstellungen ignorieren.",
      "contentLayout": "Inhaltslayout",
      "contentLayoutDefault": "Inhaltslayout wählen",
      "priority": "Priorität",
      "priorityDefault": "Deaktiviert",
      "priorityTooltip": "Torrentwarteschlangen wird für dich aktiviert, wenn es deaktiviert ist. Stelle sicher, dass du deine bevorzugten Limits dafür in deinem Client festlegst.",
      "firstLastPiece": "Erste und letzte Teile zuerst herunterladen",
      "firstLastPieceDescription": "Torrent hinzufügen und erste und letzte Teile zuerst herunterladen"
    },
    "deluge": {
      "label": "Label",
      "labelPlaceholder": "z.B. label1 (muss in Deluge vorhanden sein)",
      "skipHashCheckTooltip": "Dies funktioniert nur mit Deluge v2."
    },
    "transmission": {
      "label": "Torrentlabel (mme)",
      "labelPlaceholder": "z.B. label1,label2"
    },
    "rtorrent": {
      "label": "Label",
      "labelPlaceholder": "z.B. label1,label2",
      "renameToPath": "Torrentnamen nicht zum Pfad hinzufügen",
      "renameDefault": "Nein"
    },
    "porla": {
      "preset": "Voreinstellung",
      "presetPlaceholder": "z.B. standard",
      "presetTooltip": "Ein groß-/kleinschreibungssensitiver Voreinstellungsname wie in Porla konfiguriert.",
      "savePathPlaceholder": "z.B. /vollständiger/pfad/zu/torrent/daten"
    }
  },
  "addForm": {
    "title": "Filter erstellen",
    "subtitle": "Neuen Filter hinzufügen.",
    "closePanel": "Panel schließen",
    "name": "Name",
    "required": "Pflichtfeld",
    "cancel": "Abbrechen",
    "create": "Erstellen",
    "added": "Filter {{name}} wurde hinzugefügt"
  }
}
